import * as yup from "yup";

/** Valores validados del flujo de carga manual desde el link público. */
export interface SendManualPublicValues {
  ccEmail?: string | null;
  invoiceDate: Date;
  invoiceNumber: string;
  total: string;
}

/**
 * Esquema de validación para el flujo de carga manual desde el link público (sin login).
 */
export const sendManualPublicSchema: yup.ObjectSchema<SendManualPublicValues> = yup
  .object()
  .shape({
    ccEmail: yup.string().email("Debe ser un correo válido"),
    invoiceDate: yup.date().required("Es Requerido"),
    invoiceNumber: yup.string().required("Es Requerido"),
    total: yup.string().required("Es Requerido"),
  })
  .required();
